const FILTER_KEYS = ["venue", "status", "created", "sent", "author"];

export const BROADCAST_LIST_DEFAULTS = {
  q: "",
  page: 1,
  sort: "created_desc",
  filters: "",
  ...Object.fromEntries(FILTER_KEYS.map((key) => [key, []])),
};

const SORT_PATTERN = /^[a-z][a-z0-9_]*_(asc|desc)$/;

export const toListParams = ({ searchTerm, activeFilters, page, sort }, venueOwnershipId) => ({
  q: searchTerm,
  page,
  sort: `${sort.key}_${sort.direction}`,
  filters: venueOwnershipId && !Object.keys(activeFilters).length ? "none" : "",
  ...Object.fromEntries(FILTER_KEYS.map((key) => [key, activeFilters[key] || []])),
});

export const fromListParams = (params, venueOwnershipId) => {
  const activeFilters = {};
  FILTER_KEYS.forEach((key) => {
    if (params[key] && params[key].length) activeFilters[key] = params[key];
  });
  if (!Object.keys(activeFilters).length && params.filters !== "none" && venueOwnershipId) activeFilters.venue = [String(venueOwnershipId)];
  const sort = SORT_PATTERN.test(params.sort) ? params.sort : BROADCAST_LIST_DEFAULTS.sort;
  const split = sort.lastIndexOf("_");
  return {
    searchTerm: params.q,
    activeFilters,
    page: params.page,
    sort: { key: sort.slice(0, split), direction: sort.slice(split + 1) },
  };
};
